import { render, staticRenderFns } from "./SearchNavItemProject.vue?vue&type=template&id=5b1c0fce&scoped=true&"
import script from "./SearchNavItemProject.vue?vue&type=script&lang=js&"
export * from "./SearchNavItemProject.vue?vue&type=script&lang=js&"
import style0 from "./SearchNavItemProject.vue?vue&type=style&index=0&id=5b1c0fce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1c0fce",
  null
  
)

export default component.exports